module.exports = __webpack_public_path__ + "img/tu_schedule_holiday.eab8dd3c.svg";